'use client';

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect, useCallback, Suspense } from 'react';
import { usePathname } from 'next/navigation';
import { useHoverIntent } from 'react-use-hoverintent';
import Link from 'next/link';
import Image from 'next/image';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart } from '@awesome.me/kit-94e593bf23/icons/sharp/light';
import { faHeart as faHeartSolid } from '@awesome.me/kit-94e593bf23/icons/sharp/solid';
import { faListUl } from '@awesome.me/kit-94e593bf23/icons/sharp/light';
import { useFavorites } from '@/app/_lib/hooks';
import { decodeEntities } from '@/app/_lib/services/ClientUtil';
import getCustomerFavoritesAction from '@/app/_lib/actions/GetCustomerFavoritesAction';
const FavoritesPreview = t0 => {
  const $ = _c(30);
  const {
    favorites,
    lastAddedSubProductId,
    onClose
  } = t0;
  if (!favorites || favorites.length === 0) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <span className="text-light text-sm">No favorites yet</span>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] !== onClose) {
      t2 = <div className="w-[320px]"><div className="p-4 flex items-center justify-between">{t1}<Link href="/" className="text-primary text-sm hover:underline" onClick={onClose}>Start Browsing</Link></div></div>;
      $[1] = onClose;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  const totalLists = favorites.length;
  let t1;
  if ($[3] !== favorites) {
    t1 = favorites.reduce(_temp, 0);
    $[3] = favorites;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const totalFavorites = t1;
  let lastAddedProduct = null;
  if (lastAddedSubProductId) {
    if ($[5] !== favorites || $[6] !== lastAddedSubProductId) {
      for (const list_0 of favorites) {
        if (list_0.products) {
          const found = list_0.products.find(p => p.sub_product_id === lastAddedSubProductId);
          if (found) {
            lastAddedProduct = found;
            break;
          }
        }
      }
      $[5] = favorites;
      $[6] = lastAddedSubProductId;
      $[7] = lastAddedProduct;
    } else {
      lastAddedProduct = $[7];
    }
  }
  if (!lastAddedProduct) {
    if ($[8] !== favorites) {
      for (const list_1 of favorites) {
        if (list_1.products && list_1.products.length > 0) {
          lastAddedProduct = list_1.products[0];
          break;
        }
      }
      $[8] = favorites;
      $[9] = lastAddedProduct;
    } else {
      lastAddedProduct = $[9];
    }
  }
  let t2;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex items-center gap-2 mb-1"><FontAwesomeIcon icon={faHeartSolid} className="text-primary text-sm" /><span className="text-sm font-medium text-ink-dark">Your Favorites</span></div>;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const t3 = totalFavorites === 1 ? "item" : "items";
  let t4;
  if ($[11] !== t3 || $[12] !== totalFavorites) {
    t4 = <span>{totalFavorites} {t3}</span>;
    $[11] = t3;
    $[12] = totalFavorites;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <FontAwesomeIcon icon={faListUl} className="text-2xs" />;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const t6 = totalLists === 1 ? "list" : "lists";
  let t7;
  if ($[15] !== t6 || $[16] !== totalLists) {
    t7 = <span className="flex items-center gap-1">{t5}{totalLists} {t6}</span>;
    $[15] = t6;
    $[16] = totalLists;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t4 || $[19] !== t7) {
    t8 = <div className="p-4 border-b border-gray-5">{t2}<div className="flex items-center gap-4 text-xs text-light">{t4}{t7}</div></div>;
    $[18] = t4;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== lastAddedProduct || $[22] !== onClose) {
    t9 = lastAddedProduct && <div className="p-4 border-b border-gray-5"><div className="text-xs text-light mb-2 text-left">Last Added</div><Link href={lastAddedProduct.url || "#"} onClick={onClose} className="group flex items-start gap-3 hover:bg-gray-2 -mx-2 px-2 py-1 rounded transition-colors"><div className="w-16 h-16 flex-shrink-0 flex items-center justify-center overlay-block p-1">{lastAddedProduct.thumb_1 ? <Image src={`${process.env.NEXT_PUBLIC_RESOURCE_URL}/thumbs/${lastAddedProduct.thumb_1}`} alt={decodeEntities(lastAddedProduct.sub_product_name) || "Product"} width={64} height={64} className="max-w-14 max-h-14 w-auto h-auto object-contain" /> : lastAddedProduct.product_photo ? <Image src={`${process.env.NEXT_PUBLIC_RESOURCE_URL}/${lastAddedProduct.product_photo}`} alt={decodeEntities(lastAddedProduct.sub_product_name) || "Product"} width={64} height={64} className="max-w-14 max-h-14 w-auto h-auto object-contain" /> : <div className="w-16 h-16 flex items-center justify-center bg-gray-2"><FontAwesomeIcon icon={faHeart} className="text-gray-10 text-xl" /></div>}</div><div className="flex-1 min-w-0 text-start"><span className="text-sm font-medium text-ink-dark line-clamp-2 leading-tight">{decodeEntities(lastAddedProduct.sub_product_name) || "Product"}</span>{lastAddedProduct.supplier_name && <span className="text-xs text-light block mt-1">{lastAddedProduct.supplier_name}</span>}</div></Link></div>;
    $[21] = lastAddedProduct;
    $[22] = onClose;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== onClose) {
    t10 = <div className="p-4 bg-gray-1 rounded-b-lg"><Link href="/favorites" className="block w-full text-center bg-gray-5 hover:bg-primary text-ink hover:text-white text-sm font-medium py-2.5 px-4 rounded transition-colors" onClick={onClose}>View Favorites</Link></div>;
    $[24] = onClose;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== t10 || $[27] !== t8 || $[28] !== t9) {
    t11 = <div className="w-[320px]">{t8}{t9}{t10}</div>;
    $[26] = t10;
    $[27] = t8;
    $[28] = t9;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  return t11;
};
const HeaderFavoritesIcon = t0 => {
  const $ = _c(26);
  const {
    className
  } = t0;
  const pathname = usePathname();
  const {
    favorites: favoritesIds
  } = useFavorites();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [favorites, setFavorites] = useState(t1);
  const [lastAddedSubProductId, setLastAddedSubProductId] = useState(null);
  const [, setHasFavorites] = useState(false);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      sensitivity: 6,
      interval: 100,
      timeout: 300
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [isIntentHover, intentRef, setIsIntentHover] = useHoverIntent(t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setFavorites([]);
      setLastAddedSubProductId(null);
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== favoritesIds) {
    t4 = [favoritesIds];
    $[3] = favoritesIds;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[5] !== favorites.length || $[6] !== isIntentHover) {
    t5 = () => {
      if (isIntentHover && favorites.length === 0) {
        const fetchFavorites = async () => {
          const response = await getCustomerFavoritesAction({
            with_products: true
          });
          if (response.success && response.favorites) {
            setFavorites(response.favorites);
            setLastAddedSubProductId(response.lastAddedSubProductId);
            const totalItems = response.favorites.reduce(_temp2, 0);
            setHasFavorites(totalItems > 0);
          }
        };
        fetchFavorites();
      }
    };
    t6 = [isIntentHover, favorites.length];
    $[5] = favorites.length;
    $[6] = isIntentHover;
    $[7] = t5;
    $[8] = t6;
  } else {
    t5 = $[7];
    t6 = $[8];
  }
  useEffect(t5, t6);
  let t7;
  if ($[9] !== setIsIntentHover) {
    t7 = () => {
      setIsIntentHover(false);
    };
    $[9] = setIsIntentHover;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const handleIconClick = t7;
  let t8;
  if ($[11] !== setIsIntentHover) {
    t8 = () => {
      setIsIntentHover(false);
    };
    $[11] = setIsIntentHover;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const handleClosePreview = t8;
  const showPreview = isIntentHover && pathname !== "/favorites";
  const t9 = `relative ${className || ""}`;
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Suspense><FontAwesomeIcon icon={faHeart} aria-hidden="true" className="hover:text-primary text-[1.75rem] lg:text-nav-icon group-[.transparent]/header:text-white" /></Suspense>;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== handleIconClick) {
    t11 = <Link href="/favorites" aria-label="View favorites" onClick={handleIconClick} className="relative block">{t10}</Link>;
    $[14] = handleIconClick;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== favorites || $[17] !== handleClosePreview || $[18] !== lastAddedSubProductId || $[19] !== showPreview) {
    t12 = showPreview && <div className="hidden lg:block absolute top-full right-0 pt-4 z-[100]" role="dialog" aria-label="Favorites preview"><div className="absolute top-2 right-1 w-0 h-0 border-l-8 border-r-8 border-b-8 border-l-transparent border-r-transparent border-b-white z-10" /><div className="bg-white rounded-lg shadow-lg border border-gray-5 -mr-3"><FavoritesPreview favorites={favorites} lastAddedSubProductId={lastAddedSubProductId} onClose={handleClosePreview} /></div></div>;
    $[16] = favorites;
    $[17] = handleClosePreview;
    $[18] = lastAddedSubProductId;
    $[19] = showPreview;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== intentRef || $[22] !== t11 || $[23] !== t12 || $[24] !== t9) {
    t13 = <div ref={intentRef} className={t9}>{t11}{t12}</div>;
    $[21] = intentRef;
    $[22] = t11;
    $[23] = t12;
    $[24] = t9;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  return t13;
};
export default HeaderFavoritesIcon;
function _temp(sum, list) {
  return sum + (list.favorites?.length || 0);
}
function _temp2(sum, list) {
  return sum + (list.favorites?.length || 0);
}